import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'About Us',
    paragraph:"Tilak.io was founded in September 2020. With different customers around the world, we are a team of experts ready to support you with your development."
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses} id="about-us">
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                  <p className="m-0">

    With a senior expertise in different fields: <br/>Project Management, Deep learning models, Python tools, C programming, Linux C++, Qt, Docker, … <br/> We offer development services for industry.<br/> <br/>
                  </p>
      <h4 className='mt-0 mb-8'> How do we defines ourselves? </h4>
                  <p className="m-0">
                    <ul>
                      <li><b>Pro-Active</b>: We team up with you to make your project succeed</li>
                      <li><b>Present and Available</b>: You're constantly informed about the project progress, making sure we meet your needs.</li>
                      <li><b>Hard workers</b>: We're not affraid of new challenges and high work load in tight schedule !</li>
                      </ul>
                      Give us a yell, we want to hear about your project!
                  </p>
                </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/-ksRfKWfZp8?si=SMbsLS9Kh7GUbda8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
